// Form.vue only knows the user's last-used group, not their role level
// there (no query loads that without a new round-trip); a user who manages
// forms elsewhere but was last an editor (level 3) in that group gets a 403
// from createForm's group gate. Rather than add a query, retry once without
// group_id when that specific 403 comes back.
export default function isGroupForbiddenError(err) {
  return !!(err
    && Array.isArray(err.graphQLErrors)
    && err.graphQLErrors.some((e) => e && e.extensions && e.extensions.code === '403'));
}
